import { Component, OnInit } from '@angular/core';
import { ShopifyResolver } from '../../install/shared/resolvers/shopify_resolver';
import { RedirectService } from '../../shared/services/redirect.service';
import { take } from 'rxjs/operators';
import { REDCRSS_EVENT_PROPERTIES, REDCRSS_EVENT_TYPES } from '../../shared/services/constants/redcross_evemts';
import { AnalyticsTrackingProvider } from '@yotpo-ui/core';


@Component({
  selector: 'yi-shopify2-setup',
  template: require('./shopify2-setup.component.html'),
  styles: [require('./shopify2-setup.component.scss')]
})
export class Shopify2SetupComponent implements OnInit {

  header = 'SHOPIFY2_SETUP.LOADING_STATE.TITLE';
  description = 'SHOPIFY2_SETUP.LOADING_STATE.DESCRIPTION';
  processFailed = false;
  constructor(private shopifyResolver: ShopifyResolver,
              private redcrossService: AnalyticsTrackingProvider,
              private redirectService: RedirectService) { }

  ngOnInit(): void {
    this.shopifyResolver.init().pipe(take(1)).subscribe((shopDeeplink: {shopDeeplink: string, err: string}) => {
      if (shopDeeplink && shopDeeplink.shopDeeplink) {
        this.redirectService.redirectTo(shopDeeplink.shopDeeplink);
        this.redcrossService.track(REDCRSS_EVENT_TYPES.INTERNAL_CHECK,
          {
            product: REDCRSS_EVENT_PROPERTIES.PRODUCT,
            checkName: 'Link Eligibility',
            featureName: 'Shopify 2.0',
            stringCheckValue: 'Success'
          });
      }else {
        this.processFailed = true;
        this.header = 'SHOPIFY2_SETUP.ERROR.TITLE';
        this.description = 'SHOPIFY2_SETUP.ERROR.DESCRIPTION';
        this.redcrossService.track(REDCRSS_EVENT_TYPES.INTERNAL_CHECK,
          {
            product: REDCRSS_EVENT_PROPERTIES.PRODUCT,
            checkName: 'Link Eligibility',
            featureName: 'Shopify 2.0',
            stringCheckValue: 'Fail',
            failReason: shopDeeplink.err
          });
      }
    });
  }

}
